import { render } from "./TakeOutProductBroadwise.vue?vue&type=template&id=1753ccf7&scoped=true"
import script from "./TakeOutProductBroadwise.vue?vue&type=script&lang=js"
export * from "./TakeOutProductBroadwise.vue?vue&type=script&lang=js"

import "./TakeOutProductBroadwise.vue?vue&type=style&index=0&id=1753ccf7&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1753ccf7"]])

export default __exports__